export default __webpack_public_path__ + "static/media/wood.f0c57697.png";